<template>
  <div class="block" style="padding: 0 10%;">
    <div class="container">
      <section class="section mt-6">
        <div class="columns is-desktop has-text-primary">
          <div class="column">
            <img alt="Team" src="../../assets/teams/ibiyinka.png" />
          </div>
          <div class="column is-three-fifths ml-5 pl-5">
            <h3 class="is-size-3 bold-text mt-3 pt-5"><b>Ibiyinka Oladeji</b></h3>
            <p class="regular-text has-text-primary mt-5">
              Ibiyinka Oladeji is a graduate of University of Ibadan, She proceeded to the Nigerian Law School and was called to the Nigerian Bar in the year 1999.
            </p>
            <p class="regular-text has-text-primary mt-3">
              She is a member of Nigerian Bar Association, Christian Lawyers Fellowship of Nigeria and also a graduate of Daystar Leadership Academy. Yinka is happily married.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamInfo",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @font-face {
    font-family: "MontBold";
    src: url("../../fonts/Mont/Mont-Bold.otf");
  }

  @font-face {
    font-family: "MontRegular";
    src: url("../../fonts/Mont/Mont-Regular.otf");
  }

  .bold-text {
    font-family: "MontBold";
  }

  .regular-text {
    font-family: "MontRegular";
  }
</style>
